(function() {
  'use strict';

  function getVisibleTrack(section) {
    const tracks = section.querySelectorAll('[data-carousel-track]');
    for (let i = 0; i < tracks.length; i++) {
      const style = window.getComputedStyle(tracks[i]);
      if (style.display !== 'none' && !tracks[i].hidden) {
        return tracks[i];
      }
    }
    return tracks[0] || null;
  }

  function getItemWidth(grid) {
    const item = grid.querySelector('.product-grid__item');
    if (!item) return 0;
    const gap = parseInt(window.getComputedStyle(grid).gap || window.getComputedStyle(grid).columnGap, 10) || 0;
    return item.offsetWidth + gap;
  }

  function getPerRow(grid) {
    const raw = window.getComputedStyle(grid).getPropertyValue('--products-per-row').trim();
    return parseInt(raw, 10) || 4;
  }

  function updateArrows(section) {
    const grid = getVisibleTrack(section);
    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    if (!grid || !prev || !next) return;

    const hasOverflow = grid.scrollWidth > grid.clientWidth + 1;
    if (!hasOverflow) {
      prev.hidden = true;
      next.hidden = true;
      return;
    }

    prev.hidden = false;
    next.hidden = false;
    prev.disabled = grid.scrollLeft <= 1;
    next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
  }

  function scrollCarousel(section, direction) {
    const grid = getVisibleTrack(section);
    if (!grid) return;
    const itemWidth = getItemWidth(grid);
    if (!itemWidth) return;
    const perRow = getPerRow(grid);
    const currentIndex = Math.round(grid.scrollLeft / itemWidth);
    const totalItems = grid.children.length;
    const newIndex = Math.min(Math.max(currentIndex + (direction * perRow), 0), Math.max(totalItems - 1, 0));
    grid.scrollTo({ left: newIndex * itemWidth, behavior: 'smooth' });
  }

  function initSection(section) {
    if (section.dataset.carouselInitialized) return;
    section.dataset.carouselInitialized = 'true';

    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');

    if (prev) {
      prev.addEventListener('click', () => scrollCarousel(section, -1));
    }
    if (next) {
      next.addEventListener('click', () => scrollCarousel(section, 1));
    }

    section.addEventListener('scroll', (e) => {
      const track = e.target.closest('[data-carousel-track]');
      if (track) updateArrows(section);
    }, true);

    window.addEventListener('resize', () => updateArrows(section));
    window.addEventListener('product-carousel:updated', (e) => {
      if (e.detail && e.detail.section === section) {
        updateArrows(section);
      }
    });

    updateArrows(section);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-carousel').forEach(initSection);
  });
})();
